import script from "./ValueProp.vue?vue&type=script&setup=true&lang=js"
export * from "./ValueProp.vue?vue&type=script&setup=true&lang=js"

import "./ValueProp.vue?vue&type=style&index=0&id=3d6f60dc&lang=scss&scoped=true"
import "./ValueProp.vue?vue&type=style&index=1&id=3d6f60dc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6f60dc"]])

export default __exports__